import { render } from "./DocumentCreationModal.vue?vue&type=template&id=14e0713b&scoped=true"
import script from "./DocumentCreationModal.vue?vue&type=script&lang=js"
export * from "./DocumentCreationModal.vue?vue&type=script&lang=js"

import "./DocumentCreationModal.vue?vue&type=style&index=0&id=14e0713b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e0713b"]])

export default __exports__